import { render, staticRenderFns } from "./TaskGLSelection.vue?vue&type=template&id=e27ab0b4"
import script from "./TaskGLSelection.vue?vue&type=script&lang=js"
export * from "./TaskGLSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports